import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';
import * as actionTypes from './action-types';
import { COUNTRY_COURSE_TYPE } from '../../constants';

export function* getCountryYearGroups(action) {
    const {
        countryCode,
        success = actions.getCountryYearGroupSuccess,
        failure = actions.getCountryYearGroupFailure
    } = action;

    const response = yield call(api.getCountryYearGroups, { countryCode });
    if (response.status === 200) {
        yield put(success(response.data));
    } else {
        yield put(failure());
    }
}

export function* getCountryYearGroupsSaga() {
    yield takeLatest(actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST, getCountryYearGroups);
}

export function* getYearGroup() {
    const payload = yield call(api.getYearGroups);
    if (payload.status === 200) {
        yield put({ type: actionTypes.GET_YEAR_GROUP_SUCCESS, data: payload });
    } else {
        yield put({ type: actionTypes.GET_YEAR_GROUP_FAILURE });
    }
}

export function* getYearGroupsSaga() {
    yield takeLatest(actionTypes.GET_YEAR_GROUP_REQUEST, getYearGroup);
}

export function* getCourseCountry({ selectedProductId }) {
    const countriesRequest = { ProductId: selectedProductId };
    const response = yield call(api.getCourseCountries, countriesRequest);
    if (response.status === 200) {
        yield put(actions.getCourseCountrySuccess(response.data));
    } else {
        yield put(actions.getCourseCountryFailure());
    }
}

export function* getCourseCountrySaga() {
    yield takeLatest(actionTypes.GET_COUNTRY_REQUEST, getCourseCountry);
}

export function* getConquestCourseCountry({ selectedProductId, countryCourseType = COUNTRY_COURSE_TYPE.CONQUEST }) {
    const countriesRequest = { ProductId: selectedProductId, countryCourseType };
    const response = yield call(api.getConquestCourseCountries, countriesRequest);
    if (response.status === 200) {
        yield put(actions.getConquestCourseCountrySuccess(response.data));
    } else {
        yield put(actions.getConquestCourseCountryFailure());
    }
}

export function* getConquestCourseCountrySaga() {
    yield takeLatest(actionTypes.GET_CONQUEST_COUNTRY_REQUEST, getConquestCourseCountry);
}

export function* getProductCourse({ countryCode, productId, yearGroup }) {
    const countriesRequest = { countryCode, productId, yearGroup };
    const response = yield call(api.getProductCourses, countriesRequest);
    if (response.status === 200) {
        yield put(actions.getProductCourseSuccess(response.data));
    } else {
        yield put(actions.getProductCourseFailure());
    }
}

export function* getProductCourseSaga() {
    yield takeLatest(actionTypes.GET_PRODUCT_COURSE_REQUEST, getProductCourse);
}

export function* getSchoolCourse({ yearGroup }) {
    const request = { yearGroup };
    const response = yield call(api.getSchoolCourses, request);
    if (response.status === 200) {
        yield put(actions.getSchoolCourseSuccess(response.data));
    } else {
        yield put({ type: actionTypes.GET_SCHOOL_COURSE_FAILURE });
    }
}

export function* getSchoolCourseSaga() {
    yield takeLatest(actionTypes.GET_SCHOOL_COURSE_REQUEST, getSchoolCourse);
}

export function* getFilteredConquestCourse({ countryCode, productId, yearGroup, selectGenericCourses, includeGlobalCourses }) {
    const countriesRequest = { countryCode, productId, yearGroup, selectGenericCourses, includeGlobalCourses };
    const response = yield call(api.getConquestFilteredCourses, countriesRequest);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_FILTERED_CONQUEST_COURSES_SUCCESS,
            data: response.data,
            isProductCoursesLoaded: true,
            isProductCoursesFetching: false
        });
    } else {
        yield put({ type: actionTypes.GET_FILTERED_CONQUEST_COURSES_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false });
    }
}

export function* getFilteredConquestCourseSaga() {
    yield takeLatest(actionTypes.GET_FILTERED_CONQUEST_COURSES_REQUEST, getFilteredConquestCourse);
}



// WEBPACK FOOTER //
// ./app/containers/assign-courses-conquest/saga.js